/**
 * Environment detection utilities
 * 
 * Detects whether the app is running in development/preview mode vs production.
 * This allows different authentication requirements per environment.
 */

/**
 * Check if we're running in Lovable's development/preview environment
 */
export function isDevEnvironment(): boolean {
  const hostname = window.location.hostname;
  
  // Lovable preview patterns
  if (hostname.includes('lovableproject.com')) return true;
  if (hostname.includes('id-preview--')) return true;
  if (hostname === 'localhost') return true;
  if (hostname === '127.0.0.1') return true;
  // Local network / private IPs for device testing
  if (hostname.endsWith('.local')) return true;
  if (/^10\.\d{1,3}\.\d{1,3}\.\d{1,3}$/.test(hostname)) return true;
  if (/^192\.168\.\d{1,3}\.\d{1,3}$/.test(hostname)) return true;
  if (/^172\.(1[6-9]|2\d|3[0-1])\.\d{1,3}\.\d{1,3}$/.test(hostname)) return true;
  
  return false;
}

/**
 * Check if we're running in production (published app)
 */
export function isProdEnvironment(): boolean {
  return !isDevEnvironment();
}

/**
 * Check if authentication should be required
 * In dev: auth is optional
 * In prod: auth is required
 */
export function isAuthRequired(): boolean {
  const forceAuthInDev = import.meta.env.VITE_REQUIRE_AUTH_IN_DEV === 'true';
  if (forceAuthInDev) return true;
  return isProdEnvironment();
}
